enum FoundationRoute {
  APPLICATION = '/application',
  COOKIES_POLICY = '/login/cookies-policy',
  FORGOT_PASSWORD = '/forgot-password',
  INACTIVITY = '/inactivity',
  LOGIN = '/login',
  ACCOUNT_ACTIVATE = '/activate'
}

enum ApplicationRoute {
  DASHBOARD = '/application/dashboard',
  SETTINGS = '/application/settings',
  OS_GENERATED = '/application/os-generated',
  COMPOSED_CHART = '/application/composed-chart',
}

export {
  ApplicationRoute,
  FoundationRoute,
};
